import React, { useState, useReducer } from "react";
import { Button, Form, Modal, TextArea, Dropdown } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";
import { AvOptions } from "./DropdownOptions/AvOptions";

function Note(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const [NewAVOptions, set_Od_Val] = useState(AvOptions);
  // const [currentValue, set_Od_currentValue_Val] = useState(AvOptions)
  // const [ogVal, set_Og_Val] = useState(AvOptions)

  const { ID, syncData, AuthState } = props;

  const handleAddition = (e, { value }) => {
    set_Od_Val((prevState) => [
      { key: value + Date.now(), text: value, value },
      ...prevState,
    ]);
  };

  const onValueChanged = async () => {
    const ValuesToCreate = {
      fk_id_patientConsul: ID,
      created_by: AuthState.user_name,
      og: state.og,
      od: state.od,
      fk_id_examen: 3,
      observation: state.observation,
    };

    axios({
      method: "post",
      responseType: "json",
      url: `${server}Consultation`,
      data: ValuesToCreate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        syncData(response.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  return (
    <>
      <Button
        color="olive"

        onClick={() => dispatch({ type: ACTION.OPEN, size: "small" })}
      >
        A.V (SC)
      </Button>
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      >
        <Modal.Header>Acuité visuelle sans correction</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths="equal">
              <Form.Field
                value={state.od}
                onAddItem={handleAddition}
                search
                selection
                fluid
                allowAdditions
                label="Oeil Droit"
                control={Dropdown}
                options={NewAVOptions}
                placeholder="OD"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_od,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_Od_Val(data);
              // }}
              />
              <Form.Field
                value={state.og}
                onAddItem={handleAddition}
                search
                selection
                fluid
                allowAdditions
                label="Oeil Gauche"
                control={Dropdown}
                options={NewAVOptions}
                placeholder="OG"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_og,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_Og_Val(data);
              // }}
              />
            </Form.Group>
            <TextArea
              placeholder="Ajouter une observation"
              //  onInput={(e, data) => dispatch({ type: ACTION.Fill_FORM_DATA, payload: data })}
              onChange={(e, data) =>
                dispatch({
                  type: ACTION.Fill_FORM_DATA_3_COLUMN_observation,
                  payload: data.value,
                })
              }
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
            Retour
          </Button>
          <Button positive onClick={onValueChanged}>
            Valider
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Note;
